<!-- eslint-disable max-len -->
<template>
  <img src="@/assets/img_website_logo.png" />
</template>

<script>
export default {};
</script>
